<template>
    <div>
        <div class="row">
            <div class="col-12 mb-1">
                <label class="form-label">Tarih</label>
                <v-validator :errors="errors" parameter="Date" :watch="value.Date">
                    <v-date-picker placeholder="Tarih" v-model="value.Date" v-on:change="getEmployeeDetail" :disabled="gettingDetail"></v-date-picker>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Görevlendirilen Personel</label>
                <v-validator :errors="errors" parameter="EmployeeId" :watch="employee">
                    <v-select-list v-model="employee" :options="employees" label="Combine" v-on:input="getEmployeeDetail" v-on:search="searchEmployees" placeholder="Görevlendirilen Personel" :loading="employeeLoading" :disabled="gettingDetail"></v-select-list>
                </v-validator>
            </div>
            <div class="col-md-6 mb-1 mb-md-0">
                <label class="form-label">Görev Başlangıç Saati</label>
                <v-validator :errors="errors" parameter="StartTime" :watch="value.StartTime">
                    <v-date-picker type="time" placeholder="Görev Başlangıç Saati" v-model="value.StartTime" ></v-date-picker>
                </v-validator>
            </div>
            <div class="col-md-6 mb-1 mb-md-0">
                <label class="form-label">Görev Bitiş Saati</label>
                <v-validator :errors="errors" parameter="EndTime" :watch="value.EndTime">
                    <v-date-picker type="time" placeholder="Görev Bitiş Saati" v-model="value.EndTime"></v-date-picker>
                </v-validator>
            </div>
        </div>
        <template v-if="detail != null">
            <hr/>
            <div class="row">
                <div class="col-12">
                    <div class="table-responsive mb-0">
                        <table class="table table-sm table-bordered">
                            <tr>
                                <th class="font-weight-bolder w-60">Toplam Süre (Saat)</th>
                                <td class="w-40 text-right">{{ time }}</td>
                            </tr>
                            <tr>
                                <th class="font-weight-bolder w-60">Ham Saat ücreti (TL/Saat)</th>
                                <td class="w-40 text-right">{{ $safe(detail,'RawHourlyAmountStr') }}</td>
                            </tr>
                            <tr>
                                <th class="font-weight-bolder w-60">Çarpan</th>
                                <td class="w-40 text-right">{{ fmCarpani || 0 }}</td>
                            </tr>
                            <tr>
                                <th class="font-weight-bolder w-60">Net Hesaplama Ücreti (TL)</th>
                                <td class="w-40 text-right">{{ formatMoney(netHesapUcreti) }} ₺</td>
                            </tr>
                            <tr class="bg-light">
                                <th class="font-weight-bolder w-60">Ödenecek Tutar (TL)</th>
                                <td class="w-40 text-right">{{ formatMoney(payAmount) }} ₺</td>
                            </tr>
                            <tr>
                                <th class="font-weight-bolder w-60">Yemek Tutarı (TL/FM)</th>
                                <td class="w-40 text-right">{{ formatMoney(yemekPrim) || 0 }} ₺</td>
                            </tr>
                            <tr>
                                <th class="font-weight-bolder w-60">Öğün Sayısı</th>
                                <td class="w-40 text-right">
                                    <b-form-spinbutton min="0" v-model="value.FoodCount" size="sm"></b-form-spinbutton>
                                </td>
                            </tr>
                            <tr class="bg-light">
                                <th class="font-weight-bolder w-60">Toplam Tutar (TL)</th>
                                <td class="w-40 text-right">{{ formatMoney(total) }} ₺</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import moment from 'moment'
import SystemConstantParametersApi from '@/api/system-constant-parameters'
import { BFormSpinbutton } from 'bootstrap-vue';

export default {
    components:{
        BFormSpinbutton,
    },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return {
            employees:[],
            employeeLoading:false,
            detail:null,
            gettingDetail:false,
            fmCarpani:0,
            yemekPrim:0
        }
    },
    mounted(){
        this.getFMCarpani()
        this.getYemekPirim()
    },
    methods:{
        searchEmployees(search){
            if(search){
                this.employeeLoading = true
                EmployeeOperationsApi.Employee.Search(String(search).toLowerCase())
                .then(res=>{
                    this.employees = res.data.Data?.map(d=>({
                        ...d,
                        Combine:[d.IdentityNumber,d.FullName].join(' - ')
                    }))
                    this.employeeLoading = false
                }).catch(err=>{ 
                    this.employeeLoading = false 
                })
            }
        },
        getFMCarpani(){
            SystemConstantParametersApi.GetByCode('FM_CARPANI').then(response=>{
                this.fmCarpani = Number(response.data.Data?.replace(',','.')) ? Number(response.data.Data.replace(',','.')) : 0
            })
        },
        getYemekPirim(){
            SystemConstantParametersApi.GetByCode('FM_YEMEK_BIRIM').then(response=>{
                this.yemekPrim = Number(response.data.Data.replace(',','.')) ? Number(response.data.Data.replace(',','.')) : 0
            })
        },
        getEmployeeDetail(){
            if(this.value.Date && this.value.EmployeeId){
                this.gettingDetail = true
                EmployeeOperationsApi.FM.EmployeeInfo(this.value.EmployeeId,this.value.Date).then(res => {
                    if(res.data.Success){
                        this.detail = res.data.Data
                    }else{
                        this.$result(res)
                    }
                    this.gettingDetail = false
                }).catch(err => {
                    this.gettingDetail = false
                    this.$result(null,err)
                })
            }else this.detail = null
        },
        formatMoney(nn){
            return new Intl.NumberFormat('tr-TR', {
                currency: 'TRY',
                minimumFractionDigits: 2,
            }).format(nn)
        }
    },
    computed:{
        employee:{
            get:function(){
                return this.employees.find(s=>s.Id==this.value.EmployeeId)
            },
            set:function(value){
                this.value.EmployeeId = value?.Id || null
            }
        },
        time(){
            const roundToNearestHalfOrWhole = (seconds) => {
                let hours = seconds / 3600
                let roundedHours = Math.ceil(hours * 2) / 2
                return roundedHours
            }
            return this.value.StartTime && this.value.EndTime ? roundToNearestHalfOrWhole(Math.abs(moment(this.value.StartTime,'hh:mm').diff(moment(this.value.EndTime,'hh:mm'),'seconds'))) : 0
        },
        netHesapUcreti(){
            if(this.detail.RawHourlyAmount && this.fmCarpani){
                return this.detail.RawHourlyAmount * this.fmCarpani
            }else return 0
        },
        payAmount(){
            if(this.netHesapUcreti && this.time){
                return this.netHesapUcreti * this.time
            }else return 0
        },
        total(){
            return ((this.yemekPrim || 0) * this.value.FoodCount)
        }
    }
}
</script>